module.exports = __webpack_public_path__ + "Poppins-BlackItalic.2787e7b82ef734055cda.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-BlackItalic.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-BlackItalic.woff
// module chunks = styles